<template>
  <div>
    <vs-sidebar
      click-not-close
      parent="#notification-list"
      :hidden-background="true"
      class="full-vs-sidebar notification-list-view-sidebar items-no-padding"
      v-model="isSidebarActiveCopy"
      position-right
    >
      <div
        class="notification-list-sidebar-content px-0 sm:pb-6 h-full scroll-area"
        v-if="currentNotification"
      >
        <div
          class="flex flex-wrap items-center notification-list-header justify-between md:px-8 px-6 sm:pb-2 sm: pt-6 d-theme-dark-bg"
        >
          <div class="flex mb-4">
            <div class="flex items-center">
              <feather-icon
                :icon="$vs.rtl ? 'ArrowRightIcon' : 'ArrowLeftIcon'"
                @click="$emit('closeSidebar')"
                class="cursor-pointer mr-4"
                svg-classes="w-6 h-6"
              ></feather-icon>
              <h4 v-if="currentNotification.title">
                お知らせ
              </h4>
              <h4 v-else>(no subject)</h4>
            </div>
          </div>
        </div>

        <component
          :is="scrollbarTag"
          class="scroll-area-mail-content md:px-8 md:pb-8 pt-4 px-6 pb-6"
          :settings="settings"
          :key="$vs.rtl"
        >
          <br />
          <div v-if="isSidebarActive">
            <div class="vx-row">
              <div class="vx-col w-full">
                <notification-card :notificationContent="currentNotification" />
              </div>
            </div>
          </div>
        </component>
      </div>
    </vs-sidebar>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import NotificationCard from "./NotificationCard.vue";

import { createNamespacedHelpers } from "vuex";
const { mapActions, mapGetters } = createNamespacedHelpers("notification");

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    openNotificationId: {
      required: false,
      type: String
    }
  },
  data() {
    return {
      showThread: false,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.5
      },
      isSidebarActiveCopy: this.isSidebarActive
    };
  },
  watch: {
    isSidebarActive(value) {
      this.isSidebarActiveCopy = this.isSidebarActive;
      if (!value) {
        this.$emit("closeSidebar");
        setTimeout(() => {
          this.showThread = false;
        }, 500);
      }
    }
  },
  computed: {
    ...mapGetters(["getNotification"]),
    currentNotification() {
      return this.getNotification(this.openNotificationId);
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    }
  },
  methods: {
    ...mapActions([
      "readeNotifications",
      "fetchUnreadNotifications",
      "fetchAllNotifications"
    ]),
    moveTo(to) {
      this.$emit("closeSidebar");
      this.$emit("moveTo", to);
    }
  },
  components: {
    VuePerfectScrollbar,
    NotificationCard
  },
  async updated() {
    if (!this.currentNotification) return;
    if (!this.currentNotification.read_at) {
      await this.readeNotifications(this.currentNotification.id);
      await this.fetchUnreadNotifications();
      await this.fetchAllNotifications();
    }
  }
};
</script>
